import {
  TableCell as BaseTableCell,
  mergeSx,
  type TableCellProps as TableBodyCellProps,
} from '@shared/components';
import { deepMerge } from '@shared/utils';

interface TableCellProps extends TableBodyCellProps {
  tableCell?: TableBodyCellProps;
}

export default function TableCell(props: Readonly<TableCellProps>) {
  const { id, children, sx, tableCell: tableBodyCellProps = {}, ...restProps } = props;

  const combinedBodyCellProps = {
    ...deepMerge(restProps, tableBodyCellProps),
    sx: mergeSx(tableBodyCellProps?.sx, sx),
  };

  return (
    <BaseTableCell id={id} {...combinedBodyCellProps}>
      {children}
    </BaseTableCell>
  );
}
